(function () {
    "use strict";
  
    function initToggle(button) {
      const cartItem = button.closest(".cart__item");
      if (!cartItem) return;
  
      const wrapper = cartItem.querySelector(".ck-product_properties__wrapper");
      if (!wrapper) return;
  
      if (button.dataset.toggleInitialized === "true") return;
  
      // Obținem textele din atributele data-toggle-more și data-toggle-less
      const moreText = button.dataset.toggleMore || "View all";
      const lessText = button.dataset.toggleLess || "View less";
  
      // Setăm starea inițială - colapsat
      if (
        !wrapper.classList.contains("ck-properties-collapsed") &&
        !wrapper.classList.contains("ck-properties-expanded")
      ) {
        wrapper.classList.add("ck-properties-collapsed");
      }
  
      button.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
  
        const isExpanded = wrapper.classList.contains("ck-properties-expanded");
  
        if (isExpanded) {
          // Colapsează
          wrapper.classList.remove("ck-properties-expanded");
          wrapper.classList.add("ck-properties-collapsed");
          // Eliminăm inline style-ul dacă există
          wrapper.style.maxHeight = "";
          button.textContent = moreText;
        } else {
          // Expand - folosim scrollHeight pentru înălțimea exactă
          wrapper.classList.remove("ck-properties-collapsed");
          // Setăm înălțimea exactă folosind scrollHeight
          wrapper.style.maxHeight = wrapper.scrollHeight + "px";
          wrapper.classList.add("ck-properties-expanded");
          button.textContent = lessText;
        }
      });
  
      button.dataset.toggleInitialized = "true";
    }
  
    function initAllToggles() {
      const buttons = document.querySelectorAll(".ck-product_properties__more");
      buttons.forEach((button) => {
        initToggle(button);
      });
    }
  
    function observeCartChanges() {
      const productsContainer = document.querySelector("[data-products]");
      if (!productsContainer) return;
  
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) {
                const newButtons = node.querySelectorAll
                  ? node.querySelectorAll(".ck-product_properties__more")
                  : [];
                newButtons.forEach((button) => {
                  initToggle(button);
                });
  
                if (
                  node.classList &&
                  node.classList.contains("ck-product_properties__more")
                ) {
                  initToggle(node);
                }
              }
            });
          }
        });
      });
  
      observer.observe(productsContainer, {
        childList: true,
        subtree: true,
      });
    }
  
    function init() {
      initAllToggles();
  
      observeCartChanges();
  
      document.addEventListener("cart:build", function () {
        setTimeout(() => {
          initAllToggles();
        }, 300);
      });
    }
  
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();
  